import {
  SurveyLaunchForm as SurveyLaunchFormData,
  SurveyLaunchFormState,
} from '@ps/survey-utils';

import { SubmittableForm } from './submittable-form';

// Named "Submission", not "SurveyLaunchForm", to avoid colliding with
// @ps/survey-utils's own SurveyLaunchForm type.
// Reads the validity the schema in SurveyLaunchComponent already computed
// instead of re-deriving a narrower one.
export class SurveyLaunchSubmissionForm implements SubmittableForm {
  private constructor(private readonly _state: SurveyLaunchFormState) {}

  public static from(state: SurveyLaunchFormState): SurveyLaunchSubmissionForm {
    return new SurveyLaunchSubmissionForm(state);
  }

  // Always a full object — every section carries a default. This is
  // unlike the audience form, which has no default.
  public get data(): SurveyLaunchFormData {
    return this._state.value;
  }

  public get error(): string | null {
    if (this.valid) {
      return null;
    }

    return this._errors()[0] ?? null;
  }

  public get valid(): boolean {
    return this._state.valid;
  }

  public get isDirty(): boolean {
    return this._state.isDirty;
  }

  public showErrors(): boolean {
    return this._errors().length > 0;
  }

  private _errors(): string[] {
    return this._state.errors
      .map((error) => error.message)
      .filter((message): message is string => !!message);
  }
}
